import React, { useCallback, useMemo } from 'react'

import { Table, TableCol, TableRow } from '../../../../../components/pdf/Table'
import { TableColText, TableHeadText, TableRowLabelValue } from '../../../../../components/pdf/TableHelpers'
import Separator from '../../../../../components/pdf/Separator'
import Text from '../../../../../components/pdf/Text'
import View from '../../../../../components/pdf/View'
import {
  getReplyValue,
  findReplyByQuestionName,
  getPlaceNames,
  getAddressValue,
  getUserNames,
  totalEmployees,
  findReplyByReference,
  getJobDescription,
  filterRepliesByParentReference,
  filterRepliesByQuestionName
} from '../../_helpers/pdfHelpers'

const CompanyInfoSection = ({ serviceOrder }) => {
  const jobRoles = useMemo(() => {
    const replies = filterRepliesByQuestionName(serviceOrder.replies, 'Quantos funcionários possui nesse cargo?')
    const result = replies.map(reply => {
      return findReplyByReference(serviceOrder.replies, reply.question.parentReference)
    })
    return result
  }, [serviceOrder.replies])

  const mountInfoJobRole = useCallback(
    (reply, index) => {
      if (!reply.value) {
        return
      }
      const { setor, funcao, descricao } = getJobDescription(reply.question.name)
      const replies = filterRepliesByParentReference(serviceOrder.replies, reply.question.reference)
      const total = totalEmployees(replies)
      return (
        <TableRow key={index}>
          <TableColText>{setor}</TableColText>
          <TableColText>{funcao}</TableColText>
          <TableColText>{descricao}</TableColText>
          <TableColText>{total}</TableColText>
        </TableRow>
      )
    },
    [serviceOrder.replies]
  )

  return (
    <View pageBreakAfter id="1">
      <Separator weight={15} />
      <View pageBreakAfter>
        <Text bold size="small">
          1. IDENTIFICAÇÃO DA EMPRESA
        </Text>

        <Separator weight={8} />

        <Table width="100%">
          <TableRowLabelValue label="Razão Social" value="Banco Santander (Brasil) S.A." colSpan={2} />
          <TableRowLabelValue
            label="CNPJ"
            value={getReplyValue(findReplyByQuestionName(serviceOrder.replies, 'CNPJ'))}
            colSpan={2}
          />
          <TableRowLabelValue
            label="Número da Agência"
            value={getPlaceNames(serviceOrder.place.name).placeCode}
            colSpan={2}
          />
          <TableRowLabelValue
            label="Nome da Agência"
            value={getPlaceNames(serviceOrder.place.name).placeName}
            colSpan={2}
          />
          <TableRowLabelValue label="Endereço" value={getAddressValue(serviceOrder)} colSpan={2} />
          <TableRowLabelValue label="CNAE" value="64.22-1" colSpan={2} />
          <TableRowLabelValue label="Ramo de Atividade" value="Bancos Múltiplos com Carteira Comercial" colSpan={2} />
          <TableRowLabelValue label="Grau de Risco" value="01" colSpan={2} />
          <TableRowLabelValue label="Número de Empregados" value={totalEmployees(serviceOrder.replies)} colSpan={2} />

          <TableRow>
            <TableCol rowSpan={2}>
              <Text bold>Contratante (PAB)</Text>
            </TableCol>

            <TableCol>
              <Text bold>Empresa</Text>
            </TableCol>
            <TableCol>
              <Text>
                {getReplyValue(
                  findReplyByQuestionName(serviceOrder.replies, 'RAZÃO SOCIAL (DA EMPRESA ONDE O PAB ESTÁ LOCALIZADO)')
                )}
              </Text>
            </TableCol>
          </TableRow>

          <TableRowLabelValue
            label="Ativ. Econômica"
            value={getReplyValue(
              findReplyByQuestionName(
                serviceOrder.replies,
                'ATIVIDADE PRINCIPAL (DA EMPRESA ONDE O PAB ESTÁ LOCALIZADO)'
              )
            )}
          />
          <TableRowLabelValue
            label="Fone / Contanto / E-mail"
            value={getReplyValue(findReplyByQuestionName(serviceOrder.replies, 'TELEFONE DA AGENCIA'))}
            colSpan={2}
          />
        </Table>

        <Separator weight={15} />

        <Text bold size="small">
          1.2. IDENTIFICAÇÃO DOS RESPONSÁVEIS PELO PROGRAMA E VISTORIA
        </Text>

        <Separator weight={8} />

        <Table width="100%">
          <TableRowLabelValue
            label="Resp. Pela Agência/Programa"
            value={findReplyByQuestionName(serviceOrder.replies, 'Representante da empresa').value.name}
          />
          <TableRowLabelValue label="Cargo" value="Gerente de unidade" />
          <TableRowLabelValue label="Resp. Técnico pela Vistoria" value={getUserNames(serviceOrder).userName} />
          <TableRowLabelValue label="Cargo" value="Técnico de Segurança do Trabalho" />
          <TableRowLabelValue label="Número de Registro" value={getUserNames(serviceOrder).userCode} />
          <TableRowLabelValue label="Resp.Revisão Técnica Documento" value={'Rodrigo Ragazini'} />
          <TableRowLabelValue label="Cargo" value={'Engenheiro de Segurança do Trabalho'} />
          <TableRowLabelValue label="Número de CREA" value={'5070254889'} />
          <TableRowLabelValue
            label="E-mail / Telefone"
            value="controle.santander@bioqualynet.com.br / (11) 2393-8037"
          />
          <TableRowLabelValue label="Resp. Técnico Santander" value="Nathalia Correia Naolisk" />
          <TableRowLabelValue label="Cargo" value="Engenheira de Segurança do Trabalho" />
          <TableRowLabelValue label="E-mail" value="nnaolisk@santander.com.br" />
          <TableRowLabelValue label="Número de Registro" value="5063245374-SP" />
        </Table>
      </View>
      <Separator weight={15} />

      <View noWrap>
        <Text bold size="small">
          1.3. DESCRIÇÃO DE CARGOS
        </Text>

        <Separator weight={8} />

        <Table width="100%">
          <TableRow>
            <TableHeadText>Setor</TableHeadText>
            <TableHeadText>Função</TableHeadText>
            <TableHeadText>Descritivo de Atividades</TableHeadText>
            <TableHeadText>Nº de Funcionários</TableHeadText>
          </TableRow>
          {jobRoles.map((jobRole, index) => {
            return mountInfoJobRole(jobRole, index)
          })}

          <TableRow>
            <TableHeadText colSpan={3} align="right">
              Total de Funcionários:
            </TableHeadText>
            <TableHeadText width={'10%'}>{totalEmployees(serviceOrder.replies)}</TableHeadText>
          </TableRow>
        </Table>
      </View>

      <Separator weight={15} />
    </View>
  )
}

export default CompanyInfoSection
